import { ComponentType } from 'react';
import { createMessage, MessageProps, wrapMessage } from './message';

export default function show<T, P = void>(Component: ComponentType<MessageProps<P, T>>, props?: P) {
    return createMessage(wrapMessage(Component))(props as P);
}
